import MobileCarousel from '../../src/js/mobile-carousel';

export default class ClientTestimonialGrid {
  constructor() {
    const $els = document.querySelectorAll('.js-client-testimonials-carousel');

    $els.forEach(($el) => new MobileCarousel($el, {
      maxWidth: 768,
    }));
  }
}
